// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__contentContainer___U2EHx {
  padding-top: 32px;
  display: flex;
}

.styles__cardMarginBot___yBZG3 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
}

.styles__oneThird___WUWzI {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___WUWzI:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___WUWzI:last-child {
  margin-right: 0;
}

.styles__oneThird___WUWzI:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___WUWzI:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___WUWzI {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___WUWzI:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___WUWzI:last-child {
    margin-right: 0;
}

.styles__oneThird___WUWzI:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___WUWzI:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__section___Su0cL {
  margin-bottom: 20px;
  position: relative;
}

.styles__section___Su0cL h2 {
    margin-bottom: 20px;
  }

.styles__subSection___aBd4n {
  margin-bottom: 30px;
}

.styles__sectionNoMargin___TFLJr {
}

.styles__sectionNoMargin___TFLJr h2 {
    margin-bottom: 20px;
  }

.styles__form___Db3nH {
}

.styles__formItem___uEIIQ {
}

.styles__formItemHalf___F3fls {
}

.styles__formItemHalf___F3fls label {
    font-size: 14px;
  }

/* composes: formItemMono from helpers; */

.styles__formItemMono___ZcLUz label {
    font-size: 14px;
  }

.styles__formItemMono___ZcLUz input {
    width: 100%;
  }

.styles__input___GNIYt {
}

.styles__select___Ljrwl {
}

.styles__label___zM_4W {
}

.styles__radioButtonGroup___SYUS1 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.styles__radioButtonGroup___SYUS1 label {
  font-size: 14px;
}

.styles__radioButtonGroup___SYUS1 .styles__buttons___Zx7Lh {
  margin-top: 5px;
}

.styles__radioButtonGroup___SYUS1 .styles__buttons___Zx7Lh input:first-child {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 0;
}

.styles__radioButtonGroup___SYUS1 .styles__buttons___Zx7Lh input {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 20px;
}

.styles__submitButtons___zRwLA {
  margin-top: 20px;
}

.styles__button___sIYGK {
}

.styles__searchComponent___IS5Vp {
  width: 100%;
}

.styles__payTo___W7mSs {
  padding-top: 10px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.styles__payTo___W7mSs .styles__payToAddress___Xm2ya {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 10px;
    gap: 2px;
    color: gtGrayDark;
  }

.styles__payTo___W7mSs .styles__name___cFvL8 {
  font-weight: bold;
  padding-right: 10px;
}

.styles__payTo___W7mSs img {
  margin-bottom: -2px;
}

.styles__fileUpload___jsSEj label {
    font-size: 14px;
  }

.styles__fileUploadComponent___zK8fY {
  padding-top: 4px;
}

.styles__requestorLink___kmeW0 {
  position: relative;
  z-index: 11;
  font-size: 10px !important;
  cursor: pointer;
  text-transform: uppercase;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px !important;
}

.styles__requestorLink___kmeW0 a {
    box-shadow: none !important;
    opacity: 0.7;
    color: gtGrayDark;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.styles__requestorLink___kmeW0 a:hover {
    -webkit-text-decoration: underline;
    text-decoration: underline;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/Received/styles.css"],"names":[],"mappings":"AAIA;EAEE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EAEE,8DAAgC;AAClC;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EAEE,mBAAmB;EACnB,kBAAkB;AAKpB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;AAMA;;AAHE;IACE,mBAAmB;EACrB;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAMA;;AAHE;IACE,eAAe;EACjB;;AAIA,yCAAyC;;AAEzC;IACE,eAAe;EACjB;;AAEA;IACE,WAAW;EACb;;AAGF;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAElB;;AAEA;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AAWV;;AATE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAGE;IACE,eAAe;EACjB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAW7B;;AAVE;IACE,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,6BAAqB;IAArB,qBAAqB;EACvB;;AACA;IACE,kCAA0B;IAA1B,0BAA0B;IAC1B,mDAAa;EACf","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDark, gtRed, gtGrayMid, gtCardHeaderBG from colors;\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-top: 32px;\n  display: flex;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n  background-color: gtCardHeaderBG;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.section {\n  composes: boxWrap from helpers;\n  margin-bottom: 20px;\n  position: relative;\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.subSection {\n  margin-bottom: 30px;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.form {\n  composes: form from helpers;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n\n  label {\n    font-size: 14px;\n  }\n}\n\n.formItemMono {\n  /* composes: formItemMono from helpers; */\n\n  label {\n    font-size: 14px;\n  }\n\n  input {\n    width: 100%;\n  }\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.select {\n  composes: select from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.radioButtonGroup {\n  composes: clearfix from helpers;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.radioButtonGroup label {\n  font-size: 14px;\n}\n\n.radioButtonGroup .buttons {\n  margin-top: 5px;\n}\n\n.radioButtonGroup .buttons input:first-child {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n.radioButtonGroup .buttons input {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 20px;\n}\n\n.submitButtons {\n  margin-top: 20px;\n  composes: buttons from helpers;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.searchComponent {\n  width: 100%;\n}\n\n.payTo {\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n\n  .payToAddress {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    font-size: 10px;\n    gap: 2px;\n    color: gtGrayDark;\n  }\n}\n\n.payTo .name {\n  font-weight: bold;\n  padding-right: 10px;\n}\n\n.payTo img {\n  margin-bottom: -2px;\n}\n\n.fileUpload {\n  label {\n    font-size: 14px;\n  }\n}\n\n.fileUploadComponent {\n  padding-top: 4px;\n}\n\n.requestorLink {\n  position: relative;\n  z-index: 11;\n  font-size: 10px !important;\n  cursor: pointer;\n  text-transform: uppercase;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px !important;\n  a {\n    box-shadow: none !important;\n    opacity: 0.7;\n    color: gtGrayDark;\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n    color: gtBlue;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"contentContainer": `styles__contentContainer___U2EHx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"cardMarginBot": `styles__cardMarginBot___yBZG3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"oneThird": `styles__oneThird___WUWzI`,
	"section": `styles__section___Su0cL ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]}`,
	"subSection": `styles__subSection___aBd4n`,
	"sectionNoMargin": `styles__sectionNoMargin___TFLJr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"form": `styles__form___Db3nH ${___CSS_LOADER_ICSS_IMPORT_1___.locals["form"]}`,
	"formItem": `styles__formItem___uEIIQ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"formItemHalf": `styles__formItemHalf___F3fls ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]}`,
	"formItemMono": `styles__formItemMono___ZcLUz`,
	"input": `styles__input___GNIYt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"select": `styles__select___Ljrwl ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"label": `styles__label___zM_4W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"radioButtonGroup": `styles__radioButtonGroup___SYUS1 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"buttons": `styles__buttons___Zx7Lh`,
	"submitButtons": `styles__submitButtons___zRwLA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]}`,
	"button": `styles__button___sIYGK ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"searchComponent": `styles__searchComponent___IS5Vp`,
	"payTo": `styles__payTo___W7mSs`,
	"payToAddress": `styles__payToAddress___Xm2ya`,
	"name": `styles__name___cFvL8`,
	"fileUpload": `styles__fileUpload___jsSEj`,
	"fileUploadComponent": `styles__fileUploadComponent___zK8fY`,
	"requestorLink": `styles__requestorLink___kmeW0`
};
export default ___CSS_LOADER_EXPORT___;
